import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { FacilityService } from 'src/app/services/facility.service';
import { Location } from '@angular/common';
import { WoundService } from 'src/app/services/wound.service';
import { MatTableDataSource } from '@angular/material/table';
import { HttpResponse } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as global from 'src/app/includes/global';
import { UserTypesRelationshipService } from 'src/app/services/user-types-relationship.service';
import { UserService } from 'src/app/services/Modules/user.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-visit-report-v2',
  templateUrl: './visit-report-v2.component.html',
  styleUrls: ['./visit-report-v2.component.css']
})
export class VisitReportV2Component implements OnInit {

  currentDate = moment(new Date());
  minDate = moment(new Date()).subtract(6, 'days');
  loaderId = 'app-visit-report';
  filter: any = {
    // filterServiceDate: {
    //   startDate: moment().subtract(6, 'days'),
    //   endDate: moment()
    // },
    facilityId: null,
    providerId: null,
    companyId: null

  };
  pagination = {
    pageNo: 1,
    hasNextPage: false,
    hasPrevPage: false,
    totalRecords: 0,
    PAGE_LIMIT: 50,
    skip: 0
  };
  preDateRanges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 1 Week': [moment().subtract(6, 'days'), moment()],
    // 'Last 2 Week': [moment().subtract(13, 'days'), moment()],
    // 'Last 3 Week': [moment().subtract(20, 'days'), moment()],
    // 'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    // 'This Month': [moment().startOf('month'), moment().endOf('month')],
    // 'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  };
  isfilterServiceDateFilterSelected: boolean = true;
  filteredFacilities: Observable<string[]>;
  displayedColumns: string[] = [
    'provider', 'facility', 'sub_seq', 'initial', 'grand_total'];
  facilityControl = new FormControl();
  providerControl = new FormControl();
  facilities: Array<any> = [];
  providers: Array<any> = [];
  filteredProviders: Observable<string[]>;
  companyId: any;
  visitReport: any = [];
  dataSource: any = new MatTableDataSource([]);
  initialTotalNotes: number = 0;
  subsequentTotalNotes: number = 0;
  grandTotal: number = 0;
  companySide: boolean;
  currentUser: any;
  user_dashboard: Boolean = false;
  nursingSide: boolean;

  constructor(
    private _toastr: ToastrService,
    private _facilityService: FacilityService,
    private _route: ActivatedRoute,
    private _location: Location,
    private _wound: WoundService,
    private loader: NgxUiLoaderService,
    private _userTypesRelationshipService: UserTypesRelationshipService,
    private _userService: UserService,
    private _authService: AuthService
  ) {
    this.currentUser = this._authService.currentUser;
    this.filter.companyId = this._route.parent.snapshot.params.id;
    if (this._route.parent.snapshot.params.id) {
      this.companySide = true;
    } else {
      this.filter.companyId = this.currentUser.company_id;
    }
    if (window.location.pathname.includes('dashboard')) {
      this.user_dashboard = true;
    }
    if (window.location.pathname.includes('nursing')) {
      this.nursingSide = true;
    }
  }

  async ngOnInit() {
    this.loader.startLoader(this.loaderId);
    await this.initFacilities();
    await this.getProviderList();
    this.selectDefaultFacility();
    this.selectDefaultProvider();
    this.initVisitReport();
  }
  private filterFacilities(value: string): string[] {
    if (value) {
      const filterValue = value.toLowerCase();
      return this.facilities.filter(option => option.title.toLowerCase().indexOf(filterValue) !== -1);
    }
    else {
      return this.facilities;
    }
  }
  private filterProvider(value: string): string[] {
    if (value && this.providers.length > 0) {
      const filterValue = value.toLowerCase();
      // return this.providers.filter(option => (option.middle_name && option.middle_name.toLowerCase().indexOf(filterValue) !== -1) || option.last_name.toLowerCase().indexOf(filterValue) !== -1 || option.first_name.toLowerCase().indexOf(filterValue) !== -1);
      return this.providers.filter(option => option.full_name.toLowerCase().match(filterValue));
    }
    else {
      return this.providers;
    }
  }
  getProvidersByFacility(facilityId) {
    return new Promise<void>((resolve, reject) => {
      this._userService.getUsersByFacility(facilityId).subscribe((response: any) => {
        if (response.status === 200) {
          this.providers = response.data;
          this.providers.unshift({ _id: 'all', full_name: 'All' });
          this.selectDefaultProvider();
          this.showProviderDropdown();
          resolve();
        }
      }, error => {
        reject('error => ' + error.toString());
      });
    });
  }
  getProviderList() {
    const filter: any = {
      company_id: this.filter.companyId,
      user_type: global.USER_TYPE.DOCTOR
    };
    const projection = {
      first_name: 1,
      last_name: 1,
      full_name: 1,
      title:1
    };
    return new Promise<void>((resolve, reject) => {
      this._userService.getUsers(filter, projection).subscribe((response: any) => {
        if (response.status === 200) {
          this.providers = response.data;
          this.providers.unshift({ _id: 'all', full_name: 'All' });
          this.selectDefaultProvider();
          this.showProviderDropdown();
          resolve();
        }
      }, error => {
        reject('error => ' + error.toString());
      });
    });

  }

  onSelectProvider(event) {
    this.filter.providerId = event;
    if (event === 'all') {
      this.filter.providerId = null;
    }
  }
  showProviderDropdown(): void {
    this.filteredProviders = this.providerControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this.filterProvider(value)));
  }

  showFacilityDropdown(): void {
    this.filteredFacilities = this.facilityControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this.filterFacilities(value)));
  }
  selectDefaultProvider() {
    if (this.providers.length > 0) {
      this.filter.providerId = null;
      this.providerControl.setValue(this.providers[0].full_name);
    }
  }
  selectDefaultFacility() {
    if (this.facilities.length > 0) {
      this.filter.facilityId = null;
      this.facilityControl.setValue(this.facilities[0].title);
    }
  }
  initVisitReport() {
    this.grandTotal = 0;
    this.subsequentTotalNotes = 0;
    this.initialTotalNotes = 0;
    this.filter.pageNo = this.pagination.pageNo;
    this.loader.startLoader(this.loaderId);
    this._wound.getVisitReportV2(this.filter).subscribe({
      next: (response: any) => {
        if (response.status == 200) {
          this.visitReport = response.data.visitReport;
          this.pagination.totalRecords = response.data.totalRecords;
          this.handlePagination();
          // console.log("this.visitReport", this.visitReport);
          if (this.visitReport.length > 0) {
            for (const report of this.visitReport) {
              this.grandTotal += report.total;
              this.initialTotalNotes += report.initial_note_count;
              this.subsequentTotalNotes += report.subseq_note_count;

            }
          }
          this.dataSource.data = this.visitReport;
          this.loader.stopLoader(this.loaderId);
        }
        else {
          this.loader.stopLoader(this.loaderId);

        }
      }, error: err => {
        this.loader.stopLoader(this.loaderId);
        this._toastr.error(err, "ERROR");
      }
    });
  }

  async initFacilities() {
    const filter = {
      company_id: this.filter.companyId
    };
    const projection = {
      title: 1
    };
    const facilitiesResponse: any = await this._facilityService.getAllFacilities(filter, projection).toPromise();
    if (facilitiesResponse.status == 200) {
      this.facilities = facilitiesResponse.data.array;
      this.facilities.unshift({ _id: 'all', title: 'All' });
      this.showFacilityDropdown();
    }
  }
  async onSelectFacility($event, value) {
    if ($event.isUserInput) {
      this.filter.facilityId = value;
      if (value === 'all') {
        this.filter.facilityId = null;
        await this.getProviderList();
      }
      else {
        await this.getProvidersByFacility(this.filter.facilityId);
      }
    }
  }

  changefilterServiceDate(event) {
    if (event.startDate && event.endDate) {
      const startDate = moment(event.startDate);
      const endDate = moment(event.endDate);
      const noOfDays = endDate.diff(startDate, 'days');
      if (noOfDays > 7) {
        this.filter.filterServiceDate = {};
        this.filter.filterServiceDate.startDate = moment(event.startDate)
        this.filter.filterServiceDate.endDate = moment(this.filter.filterServiceDate.startDate).add(6, "days").startOf('day')
        this._toastr.error('Can not select more than 7 days', 'Date Error');
      }
      else {
        this.filter.filterServiceDate.startDate = moment(event.startDate)
        this.filter.filterServiceDate.endDate = moment(event.endDate)
      }
    }
  }

  goBack() {
    this._location.back();
  }
  handleApplyFilter() {
    this.initVisitReport();
  }

  resetFilter() {
    delete this.filter.filterServiceDate;
    const defaultDate = {
      startDate: moment().subtract(6, 'days'),
      endDate: moment()
    };
    this.filter.filterServiceDate = defaultDate;
    this.selectDefaultFacility();
    this.selectDefaultProvider();
    this.initVisitReport();
  }
  handlePagination() {
    this.pagination.skip = (this.pagination.pageNo - 1) * this.pagination.PAGE_LIMIT;
    if (this.pagination.skip + this.visitReport.length < this.pagination.totalRecords) {
      this.pagination.hasNextPage = true;
    }
    else {
      this.pagination.hasNextPage = false;
    }
    if (this.pagination.skip > 0) {
      this.pagination.hasPrevPage = true;
    }
    else {
      this.pagination.hasPrevPage = false;
    }
  }
  goToPreviousPage() {
    this.pagination.pageNo--;
    this.initVisitReport();
  }
  goToNextPage() {
    this.pagination.pageNo++;
    this.initVisitReport();
  }
  exportVisitReportAsXLSX() {
    const infoToastr = this._toastr.info('Exporting as XLSX...', 'Please wait', { disableTimeOut: true });
    delete this.filter.pageNo;
    this._wound.exportVisitReportV2AsXLSX(this.filter).subscribe({
      next: (response: any) => {
        if (response instanceof HttpResponse) {
          const url = window.URL.createObjectURL(response.body);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = `Visit Report`;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element
          this._toastr.clear(infoToastr.toastId);
        }
      }, error: error => {
        console.log("err", error);
        this._toastr.clear(infoToastr.toastId);
      }
    });
  }

}
